"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Z20Tool {
    constructor(index, sprite) {
        this.index = index;
        this.sprite = sprite;
    }
}
exports.default = Z20Tool;
